import React from 'react'

export default function DocxRenderComponent({ html }: { html: string }) {
  return (
    <div className={'container max-w-screen-lg mx-auto'}>
      <div
        className={
          'px-2 py-8 prose-sm w-full prose-ul:list-disc prose-ul:list-inside prose-ol:list-inside prose-ol:list-decimal'
        }
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />
    </div>
  )
}
